import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class NotificationAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Business';
  controllerName = 'Notifications';

  /**
   * Lấy dữ liệu danh sách
   */
  updateRead(payload) {
    let request = {
      url: this.getAPIUrl() + '/read',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy số thông báo chưa đọc
   */
  getUnread(payload) {
    let request = {
      url: this.getAPIUrl() + '/unread',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  initIntegrationAPI() {
    return window._apis['ITG'] + '/Notification';
  }

  /**
   * Lấy số thông báo chưa đọc
   */
  isMacNoti(payload) {
    let request = {
      url: this.initIntegrationAPI() + '/isMacNoti',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy chi tiết ISMAC
   */
  iSMACDetail(payload) {
    let request = {
      url: this.initIntegrationAPI() + '/isMacDetail',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy trạng thái bật/tắt thông báo hướng dẫn nhập chứng từ năm
   * dqdat1 15.12.2023
   */
  OffBannerInstruct(payload) {
    let request = {
      url: this.getAPIUrl() + '/OffBannerInstruct',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Tắt thông báo hướng dẫn nhập chứng từ năm
   * dqdat1 15.12.2023
   */
  UpdateOffBannerInstruct() {
    let request = {
      url: this.getAPIUrl() + '/OffBannerInstruct',
    };

    return httpClient.putAsync(request);
  }
  /**
   * Lấy trạng thái show form Update TT24
   */
  GetNotifyUpdateTT24() {
    let request = {
      url: this.getAPIUrl() + '/NotifyUpdateTT24',
    };

    return httpClient.getAsync(request);
  }
  /**
   * ẩn form Update TT24
   */
  DontShowNotifyUpdateTT24() {
    let request = {
      url: this.getAPIUrl() + '/DontShowNotifyUpdateTT24',
    };
    return httpClient.putAsync(request);
  }
}

export default new NotificationAPI();
